const searchResults = state => state.searchResults;
const isHideNavItems = state => state.isHideNavItems;

export default {
  searchResults,
  isHideNavItems,
};
